export const enums = {
  FREE: "free",
  IN_TRANSIT: "in_transit",
  REPAIR: "repair",
  MAINTENANCE: "maintenance",
};

export const mapping = {
  [enums.FREE]: "Свободен",
  [enums.IN_TRANSIT]: "В пути",
  [enums.REPAIR]: "На ремонте",
  [enums.MAINTENANCE]: "На обслуживании",
};

export const mappingStyles = {
  [enums.FREE]: {
    title: "Свободен",
    icon: "dot",
    color: "green-dark",
  },
  [enums.IN_TRANSIT]: {
    title: "В пути",
    icon: "map",
    color: "purple",
  },
  [enums.REPAIR]: {
    title: "На ремонте",
    icon: "cog",
    color: "red",
  },
  [enums.MAINTENANCE]: {
    title: "На обслуживании",
    icon: "wrench",
    color: "yellow",
  },
};
